import { http } from '@services/http'; // or '@services/http' if you added aliases

export const csrf = () => http.get('/sanctum/csrf-cookie');
export const login = (email, password) => http.post('/login', { email, password });
export const verify2FA = (code) => http.post('/two-factor/verify', { code });
export const logout = () => http.post('/logout');
// Session-status check used by the SPA on every page mount.
//
// Returns { authenticated: bool, user: User|null } with status 200 in
// both cases — anonymous and authenticated. This is intentional: the
// `AuthProvider` mounts above public routes too (/login, /activate,
// /reset-password), and a 401 here would trip the global http
// interceptor's "session-expired → /login" redirect, dropping the URL
// query string and breaking the activation / password-reset flows.
//
// `silent: true` keeps this call quiet — no error toast on transient
// 5xx, no auto-redirect on stray 401s. Since /api/auth/status returns
// 200 by design, this is mostly belt-and-suspenders, but it ensures
// a passive plumbing call never surprises the user with a global
// reaction. (Loading state is component-local now — there's no
// global progress bar to suppress, but the `silent` semantics for
// error/redirect handling still apply.)
export const me = () => http.get('/api/auth/status', { meta: { silent: true } });
export const requestReset = (email) => http.post('/api/auth/resolve', { email });
export const resetPassword = (payload) => http.post('/reset-password', payload);
export const activateTraveler = ({ token, password, password_confirmation }) =>
  http.post('/api/activation', { token, password, password_confirmation });
